import { jsx as _jsx } from "react/jsx-runtime";
import { WidgetBody } from './internal/WidgetBody.js';
/**
 * Renders a single widget's body from a precomputed view.
 *
 * Public, and deliberately dumb: it takes a `WidgetView` produced by core's
 * `computeWidgetView` and paints it. It never touches rows, never aggregates and
 * never re-derives a number.
 *
 * Unlike `ReportViewer`/`ReportEditor` (rooted in `.tf-surface`) or `PrintReport`
 * (rooted in `.tf-print`), `WidgetBody` has no root of its own — a flat table
 * even renders as a fragment, with no single outer element at all. A host
 * embedding `WidgetContent` standalone (outside any of those) would otherwise
 * receive a view with none of tokens.css's `--rp-*` custom properties defined.
 * The wrapper below gives it one: `.tf-root`, one of the classes tokens.css
 * declares them on. `display: contents` keeps the wrapper out of layout, since
 * this component makes no promises about its own box — only about what's
 * inside it — the same as before this wrapper existed.
 */
export function WidgetContent(props) {
    return (_jsx("div", { className: "tf-root", style: { display: 'contents' }, children: _jsx(WidgetBody, { view: props.view, animate: props.animate !== false, paginate: true }) }));
}
//# sourceMappingURL=WidgetContent.js.map